import type { CalendarPort } from '../../application';
import { LocalDate } from '../../domain';
import { localCalendarDay } from '../../shared/dates/journey-dates';

/** The day it is where the phone is, read from its clock each time it is asked. */
export class BrowserCalendarAdapter implements CalendarPort {
  constructor(private readonly now: () => Date = () => new Date()) {}

  today(): LocalDate {
    return LocalDate.create(localCalendarDay(this.now()));
  }
}
